export const BlueMS = () => {
  return (
    <div className="flex justify-center p-2 h-screen">
      <iframe
        className="p-4 h-screen w-screen"
        src="https://iframe.dacast.com/live/34722db9-4e7c-5b6a-03b1-492fb511cfd6/d434dfd9-612d-493d-c3bd-2ef8416f7abd"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Blue MS"
      />
    </div>
  );
};
